import { render } from "./Stats.vue?vue&type=template&id=25a69aa9&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=25a69aa9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25a69aa9"

export default script